exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select_skuName_div[data-v-bdc31b26]{-webkit-line-clamp:2}.select_skuName_div[data-v-bdc31b26],.select_skuName_div_line_3[data-v-bdc31b26]{font-size:15px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;margin-left:10px}.select_skuName_div_line_3[data-v-bdc31b26]{-webkit-line-clamp:3}", ""]);

// exports
